var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{attrs:{"toggle-text":_vm.__('Add'),"size":"small","placement":"right","items":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }